import React, { useRef, useState } from "react";
import LockerMapMobile from "./LockerMapMobile";
import { useHistory } from "react-router-dom";
import CircularProgressLoader from "./CircularProgressLoader";
import ShowToast from "./ToastComponent";
import { TOAST_ERROR } from "../assets/constants/Constants";
import {useTranslation} from 'react-i18next';
import { getUnitLabelParams } from "../lib/Utils";
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, LS_LOCKER_BANK_INFO } from "../assets/constants/BrowserStorageKeys";

import {
  fetchNearbyLockersForLocation,
  getCurrentBrowserLocation,
  getNearbyLockerErrorMessage,
} from "../lib/NearbyLockerUtils";

const LockerMapPreview = () => {
  const [isLocating, setIsLocating] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const isFindingLockersRef = useRef(false);
  const { t } = useTranslation()
  const history = useHistory();
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);

  // Default location (Pune)
  const defaultLocation = {
    lat: 18.5292,
    lng: 73.8746,
  };

  const handleFindLockers = async () => {
    if (isFindingLockersRef.current) {
      return;
    }

    isFindingLockersRef.current = true;
    setIsLocating(true);
    setShowLoader(true);
    setLoadingMessage(t('info_Message_Getting_Location'));

    try {
      const userLocation = await getCurrentBrowserLocation();
      const { lockersData: apiData } = await fetchNearbyLockersForLocation({
        userLocation,
        onLoadingMessage: setLoadingMessage,
      });

      setTimeout(() => {
        setShowLoader(false);

        history.push({
          pathname: "/map",
          state: {
            center: userLocation,
            useUserLocation: true,
            lockersData: apiData,
            timestamp: Date.now()
          },
        });
      }, 500);
    } catch (error) {
      console.log("Nearby locker flow error:", error);
      const message = getNearbyLockerErrorMessage(error);
      setShowLoader(false);
      ShowToast(message, TOAST_ERROR);
    } finally {
      isFindingLockersRef.current = false;
      setIsLocating(false);
    }
  };

  return (
      <div className="locker-map-preview"  onClick={handleFindLockers}>
        <div className="preview-map-container">
          <div className="mini-map-wrapper">
            <LockerMapMobile
              isPreview={true}
              initialLocation={defaultLocation}
            />
          </div>
        </div>
        <div
          className={`find-lockers-btn-container ${
            isLocating ? "locating" : ""
          }`}
        >
          <h1 className="find-locker-heading">
            {isLocating
              ? t('info_Message_Getting_Location')
              : t('info_Search_Locker', unitLabelParams)}
          </h1>
        </div>
        {showLoader && (
        <CircularProgressLoader message={loadingMessage} />
      )}
      </div>

      
  );
};

export default LockerMapPreview;
